import { Component } from 'react';
import { Route, Switch } from 'react-router';
import { SCREENS } from 'src/constants/screens';
import { appStore } from 'src/mobx/appStore';
import CustomRoute from 'src/view/components/CustomRoute/CustomRoute';
import { Table } from 'src/view/components/Table/Table';
import CashbackEdit from '~/view/screens/MarketingScreen/screens/Cashback/containers/CashbackEdit/CashbackEdit';
import MessageCampaignEdit from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignEditScreen/MessageCampaignEdit';
import Cashback from './screens/Cashback/Cashback';
import DealsScreen from './screens/DealsScreen/DealsScreen';
import DealsEdit from './screens/DealsScreen/containers/DealsEdit/DealsEdit';
import MessageCampaignsScreen from './screens/MessageCampaign/CampaignListScreen/MessageCampaignsScreen';
import PromobannersScreen from './screens/PromobannersScreen/PromobannersScreen';
import PromobannerCreate from './screens/PromobannersScreen/screens/PromobannerCreate/PromobannerCreate';
import PromobannerEdit from './screens/PromobannersScreen/screens/PromobannerEdit/PromobannerEdit';
import PromocodesScreen from './screens/PromocodesScreen/PromocodesScreen';

export default class MarketingScreen extends Component<{}, {}> {
  render() {
    return (
      <Table>
        <Switch>
          <Route path={SCREENS.PROMOCODES()} component={PromocodesScreen} />
          <CustomRoute exact path={SCREENS.PROMOBANNERS()} component={PromobannersScreen} access={appStore.isAddonsAvailable.promoBanners} />
          <CustomRoute path={SCREENS.PROMOBANNER_EDIT(':id')} component={PromobannerEdit} access={appStore.isAddonsAvailable.promoBanners} />
          <CustomRoute path={SCREENS.PROMOBANNER_CREATE()} component={PromobannerCreate} />

          <Route path={SCREENS.MESSAGE_CAMPAIGN_CREATE()} component={MessageCampaignEdit} />
          <Route path={SCREENS.MESSAGE_CAMPAIGN_EDIT(':id')} component={MessageCampaignEdit} />
          <Route path={SCREENS.MESSAGE_CAMPAIGNS()} component={MessageCampaignsScreen} />
          <CustomRoute exact path={SCREENS.CASHBACK()} component={Cashback} access={appStore.isAddonsAvailable.cashback} />
          <CustomRoute
            path={[SCREENS.CASHBACK_EDIT(':id'), SCREENS.CASHBACK_CREATE()]}
            component={CashbackEdit}
            access={appStore.isAddonsAvailable.cashback}
          />
          <CustomRoute exact path={SCREENS.DEALS()} component={DealsScreen} access={appStore.isAddonsAvailable.deals} />
          <CustomRoute
            path={[SCREENS.DEALS_CREATE(), SCREENS.DEALS_EDIT(':id')]}
            component={DealsEdit}
            // addon is enabled and pos is not enabled
            access={appStore.isAddonsAvailable.deals && !appStore.settings?.is_pos}
          />
        </Switch>
      </Table>
    );
  }
}
